module.exports = __webpack_public_path__ + "img/CRT_Sword-004.ad066425.png";